module.exports = __webpack_public_path__ + "static/img/tz.991424ba.png";